/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 16:21:13
 * @LastEditors: liuziwei
 * @Description: 券浮层壳子
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="drawer-frame-container">
    <controllable-drawer-bottom
      show="{{open}}"
      title="{{cusTitle}}"
      useSimpleHeader="{{!leftTitle}}"
      customStyle="{{containerStyle}}"
      headerStyle="{{headerStyle}}"
      bind:close="closeDrawer"
    >
      <!-- 自定义左侧标题 -->
      <view slot="left" wx:if="{{showPackDetail}}" class="left-title" bindtap="hidePackDetail">
        <img class="back-icon" src="https://ut-static.udache.com/webx/sfc/MD-Dc6v0Bf220jgs9XgBK.png"/>
        <view>明细</view>
      </view>
      <view slot="left" wx:elif="{{leftTitle && !useTab}}" class="left-title">
        <view style="display: flex">{{ title }}<slot name="titleSlot" /></view>
      </view>
      <view slot="left" wx:elif="{{leftTitle && useTab}}" class="left-title gray-font">
        <view wx:for="{{title}}" class="tab" wx:class="{{{'selected': curTab === item.value}}}" bindtap="changeCurTab(item)">{{item.text}}</view>
      </view>
      <!-- 内容部分 -->
      <slot></slot>
    </controllable-drawer-bottom>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  
  createComponent({
    props: {
      // drawer 开关
      open: {
        type: Boolean,
        value: () => false
      },
      // 默认的居中标题文本
      title: {
        type: String,
        optionalTypes: [Array],
        value: () => ''
      },
      // 将标题位置置于左侧
      leftTitle: {
        type: Boolean,
        value: () => false
      },
      // 自定义容器样式
      customStyle: {
        type: Object,
        value: () => {}
      },
      useTab: {
        type: Boolean,
        value: false
      },
      curTab: {
        type: String,
        value: 'coupon'
      },
      showPackDetail: {
        type: Boolean,
        value: false
      }
    },
    computed: {
      // 自定义居中标题
      cusTitle() {
        return this.leftTitle ? '' : this.title
      },
      // 自定义容器样式
      containerStyle() {
        return Object.assign(
          {
            height: 'auto',
            overflow: 'hidden',
          },
          this.customStyle
        )
      },
      headerStyle() {
        return {
          'justify-content': 'space-between',
          'padding-left': '18px',
          'padding-bottom': '20px'
        }
      }
    },
    methods: {
      // 关闭券浮层
      closeDrawer() {
        // 上报事件
        this.triggerEvent('closeDrawer')
      },
      changeCurTab(item) {
        this.triggerEvent('changeCurTab', item.value)
      },
      hidePackDetail() {
        this.triggerEvent('hidePackDetail')
      },
    }
  })
</script>

<style lang='stylus' scoped>
  .left-title
    position relative
    font-family PingFang SC
    font-size 19px
    font-weight 500
    line-height 23px
    display flex
    align-items center
    &.gray-font
      color #666
    .tab
      position relative
      &.selected 
        color #222
        &::after
          position absolute
          content ''
          bottom 0
          left 50%
          transform translateX(-50%)
          width calc(100% - 5px)
          height 4px
          background #FF6400
      &:not(:last-child)
        margin-right 28px
    .back-icon
      height 20px
      width 20px
      margin-right 4px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
    }
  }
</script>
